import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.xmcVZ0',
    defaultMessage: 'Search',
  },
  noResultsFound: {
    id: 'studio.hX5PAb',
    defaultMessage: 'No results found',
  },
  minCharLength: {
    id: 'studio.xHhWgf',
    defaultMessage: 'You need at least 3 characters to start searching',
  },
  searching: {
    id: 'studio.sZBZsJ',
    defaultMessage: 'Searching for: {cleanedNeedle}',
  },
});
